import React from 'react';
import Modal from 'react-bootstrap/Modal';

export default function MountPositionModal2({pageLanguage, modals, modalHandleClose, t}) {
  return (
   <Modal
   dialogClassName={`noMount_modal mediumSizeModal ${
     pageLanguage === "fa" ? "font_farsi" : "font_en"
   }`}
   show={modals["noMount"] === undefined ? false : modals["noMount"]}
   onHide={() => modalHandleClose("noMount")}
 >
   <Modal.Header closeButton>{/*<Modal.Title>Modal heading</Modal.Title>*/}</Modal.Header>
   <Modal.Body>
     <p>{t("modal_select_mount")}</p>

     <br />
     <div className=" text_center">
       <button className=" btn btn-new-dark" onClick={() => modalHandleClose("noMount")}>
         {t("CONTINUE")}
       </button>
     </div>
   </Modal.Body>
 </Modal>
  )
}
